import { FieldErrors, FieldValues } from 'react-hook-form';

export function getNestedErrorProperty(obj: FieldErrors<FieldValues>, path: string) {
  const keys = path.split('.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current: any = obj;

  for (const key of keys) {
    if (current[key] === undefined) {
      return undefined;
    }
    current = current[key];
  }

  return current;
}
